module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter1"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "pg_15_2",
      "src": "images/pg_15_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A Renault R-35 light tank firing in the French Alps; somewhat belatedly Mussolini joined Hitler’s attack on France on 11 June 1940, but his forces made little impression against just six French divisions. Only when Hitler’s panzers came sweeping down the Rhone Valley could Mussolini claim victory. The Franco– German armistice was signed on 22 June 1940, followed by the Franco–Italian Armistice two days later, and the war in France officially came to an end. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Collection")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b69d79a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_03_Chapter1.vue
// module id = 84
// module chunks = 0